import {
  Component,
  EventEmitter,
  Output,
} from "@angular/core";
import { ConfigurationService } from "app/shared/services/configuration.service";
import { NotificationService } from "app/shared/services/notification.service";
import { SecurityService } from 'app/shared/services/security.service';
import { Subscription } from "rxjs";

@Component({
  selector: "app-tos-update",
  templateUrl: "./tos-update.component.html",
  styleUrls: ["./tos-update.component.scss"],
})
export class TosUpdateComponent {
  @Output() toggle = new EventEmitter();
  notificationSub: Subscription;
  publicWebsiteUrl: string;
  userRouteByRole: string;

  constructor(
    private notificationService: NotificationService,
    private configurationService: ConfigurationService,
    private securityService: SecurityService
  ) {
    this.publicWebsiteUrl = this.configurationService.serverSettings.publicWebsiteUrl;
    const user = this.securityService.GetUser();
    this.userRouteByRole = user.role === "Advertiser" ? "advertisers" : "developers";
  }

  onClose() {
    this.notificationService.termsOfServiceUpdateClose();
    this.toggle.emit(false);
  }
}
